module.exports = __webpack_public_path__ + "img/Michael_Tsaban.48332d9e.png";